import React from 'react';
import Button from '@mui/material/Button';

export default function ActionCard({ name, icon, path }) {
  return (
    <Button
      variant="outlined"
      fullWidth
      disableRipple
      startIcon={icon}
      href={path}
      size="large"
      sx={{ padding: 3, backgroundColor: 'white' }}
    >
      {name}
    </Button>
  );
}
